<template>
  <div class="authentication-wrapper authentication-1 px-4 pg_login">
    <div class="authentication-inner">

      <!-- Logo -->
      <div class="d-flex">
        <div class="ui-w-60">
          <div class="w-100 position-relative" style="padding-bottom: 54%; padding-left: 40px;">
            <img data-v-40178c39="" src="data:image/svg+xml;base64,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" alt="Pragya Systems Logo" class="logo" style="height: 90px; width: auto;">
          </div>
        </div>
      </div>
      <!-- / Logo -->

      <div class="row page_fld_section" style="height: 15px; margin-bottom: 10px;">
        <div class="col-12" id="validation-message">
          <div style="color: #ff0000; text-align: center;">{{errorMessage}}</div>
        </div>
      </div>

      <!-- Form -->
      <form class="my-2">
        <div class="form-group lgn_frm_fld">
          <label class="form-label">Email</label>
          <b-form-input type="email" v-model.trim="eMail" :state="eMailState"
            aria-labelledby="email" @blur.native="$v.eMail.$touch()"
            aria-describedby="eMailFeedback" style="height: 2.5em !important;">
          </b-form-input>
          <b-form-invalid-feedback id="eMailFeedback">
            Please enter a proper email address.
          </b-form-invalid-feedback>
        </div>
        <div class="form-group lgn_frm_fld">
          <label class="form-label d-flex justify-content-between align-items-end">
            <div>Password</div>
          </label>
          <div class="password_input_fld">
            <b-form-input v-if="showPassword" type="text" v-model.trim="password" :state="passwordState"
              aria-labelledby="password" @blur.native="$v.password.$touch()"
              aria-describedby="passwordFeedback" style="height: 2.5em !important;">
            </b-form-input>
            <b-form-input v-else type="password" v-model.trim="password" :state="passwordState"
              aria-labelledby="password" @blur.native="$v.password.$touch()"
              aria-describedby="passwordFeedback" style="height: 2.5em !important;">
            </b-form-input>
            <div class="control">
              <button class="button" @click="toggleShowPassword">
                <span class="icon is-small is-right">
                  <span class="fas" :class="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"></span>
                </span>
              </button>
            </div>
          </div>
          <b-form-invalid-feedback id="passwordFeedback">
            Password must not be empty.
          </b-form-invalid-feedback>
        </div>
        <div class="pg_lnk_container">
          <a href="javascript://" class="lnk_forgot_passwd" @click="forgotPassword">Forgot Password?</a>
          <button type="button" class="btn btn-primary" @click="loginUser">Log In</button>
        </div>
        <div class="pg_lnk_container">
          <a href="javascript://" class="lnk_sign_up" @click="pragyaSignup">Don't have an account? Sign up to explore</a>
        </div>
      </form>
      <!-- / Form -->

      <div>
        <b-modal v-model="showForgotPasswordModal" title="Forgot Password" :header-bg-variant="'warning'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
          <div class="text-center" @keydown.enter="resetPassword">
            <template v-if="resetPasswordMessage">
              <span style="color: Red;">{{resetPasswordMessage}}</span>
            </template>
            <template v-else>
              <div class="float-left mr-3 mt-3">
                <div class="fld-label">Email</div>
              </div>
              <div class="ml-5">
                <b-form-input type="email" v-model.email="resetPasswordEmail" :state="resetPasswordEmailState"
                  aria-labelledby="reset email" @blur.native="$v.resetPasswordEmail.$touch()"
                  aria-describedby="resetPasswordEmailFeedback" style="height: 2.5em !important; width: 85%;">
                </b-form-input>
                <b-form-invalid-feedback id="resetPasswordEmailFeedback">
                  Please enter a proper email address.
                </b-form-invalid-feedback>
              </div>
            </template>
          </div>
          <div slot="modal-footer" class="w-100">
            <template v-if="resetPasswordMessage">
              <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">ok</b-button>
            </template>
            <template v-else>
              <b-button variant="primary" size="sm" class="float-right ml-3" @click="resetPassword">get new password</b-button>
              <b-button variant="primary" size="sm" class="float-right" @click="showForgotPasswordModal = false">cancel</b-button>
            </template>
          </div>
        </b-modal>
      </div>

      <div>
          <b-modal v-model="showSSOModal" title="Log in with your institution" no-close-on-backdrop no-close-on-esc centered>
              <div class="text-center">
                      <div class="float-left mr-3">
                          <div class="fld-label">Looks like you have an account with <b><i>{{ssoInstitutionName}}</i></b></div>
                          <div class="fld-label">Please click on the button below to log in with your <b><i>{{ssoInstitutionName}}</i></b> credentials. </div>
                      </div>
              </div>
              <div slot="modal-footer" class="w-100">
                      <b-button variant="primary" size="sm" class="float-right ml-3" @click="institutionLogin">go to institution login</b-button>
              </div>
          </b-modal>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import Vuelidate from 'vuelidate'
import {required, email} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

export default {
  name: 'login',
  props: [],
  components: {
    Autocomplete
  },
  data: () => {
    return {
      eMail: '',
      eMailState: null,
      password: '',
      passwordState: null,
      showPassword: false,
      errorMessage: '',
      resetPasswordEmail: '',
      resetPasswordEmailState: null,
      resetPasswordMessage: null,
      showForgotPasswordModal: false,
      showLoader: false,
      showSSOModal: false,
      ssoPath : undefined,
      ssoInstitutionName : '',
      ssoInstitutionLogo : '',
      ssoConfigurationList: [],
      currentEnvironment: {}
    }
  },
  validations: {
    eMail: {
      required,
      email
    },
    password: {
      required
    },
    resetPasswordEmail: {
      required,
      email
    }
  },
  mounted () {

    let utm_medium = this.getQueryParamByName('utm_medium')
    localStorage.setItem('utm_medium', utm_medium)
    let utm_source = this.getQueryParamByName('utm_source')
    localStorage.setItem('utm_source', utm_source)
    let utm_campaign = this.getQueryParamByName('utm_campaign')
    localStorage.setItem('utm_campaign', utm_campaign)
    let utm_content = this.getQueryParamByName('utm_content')
    localStorage.setItem('utm_content', utm_content)
    let utm_term = this.getQueryParamByName('utm_term')
    localStorage.setItem('utm_term', utm_term)

    this.loadLogin()
  },
  methods: {
    ...mapActions([
      'loadUserLogin',
      'loadSSOConfiguration',
      'loadEnvironment',
      'loadResetPassword'
    ]),

    toggleShowPassword () {
      this.showPassword = !this.showPassword;
    },

    getQueryParamByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, '\\$&')
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      let results = regex.exec(decodeURIComponent(url))
      if (!results || !results[2]) return ''
      return results[2].replace(/\+/g, ' ')
    },

    getSSOConfiguration () {
      this.loadSSOConfiguration().then(res => {
        if (res && res.status !== 503) {
          let data = res.data
          let shibboleth = data['shibboleth']
          const config = shibboleth.map(({id, openId, organizationName: name, targetURI, enable}) => ({
            id,
            openId,
            name,
            targetURI,
            enable
          }))
          this.ssoConfigurationList = config
          this.getEnvironment()
          this.$root.$emit('serviceAvailable', true)
        } else {
          let errorThrown = res.statusText
          this.$root.$emit('serviceAvailable', false, errorThrown)
        }
      })
    },
    getEnvironment () {
      if (Object.keys(this.currentEnvironment).length === 0) {
        this.loadEnvironment().then(res => {
          if (res && res.status !== 503) {
            this.currentEnvironment = res.data
          }
        })
      }
    },
    pragyaSignup (){
        window.open(window.location.origin + '/signup/open', '_self')
      },
    loadLogin () {
      let isUserLoggedIn = this.isUserLoggedIn()
      if (isUserLoggedIn) {
        return this.$router.push({ name: 'dashboard' })
      }
      this.getSSOConfiguration()
    },
    selectConfig (item) {
      let config = item.selectedObject
      this.loadShibbolethURL(config.name, config.id, config.targetURI, config.enable, config.openId)
    },
    loadShibbolethURL (name, entityId, targetURI, status, openId) {
      if (status === 'true') {
        let href = window.location.href.split('?')
        let paramValues = []
        if (href.length > 1) {
          let paramsString = href[1]
          paramValues = paramsString.split('=')
        }
        let secureHost = this.currentEnvironment.secureHost
        let loginUrl = secureHost
        loginUrl += '/Shibboleth.sso/Login?entityID=' + entityId
        if (paramValues.length > 1) {
          let redirect = paramValues[1].split('&')
          loginUrl += '&target=' + secureHost + targetURI + '?openId=' + openId + '__' + redirect[0]
        } else {
          loginUrl += '&target=' + secureHost + targetURI + '?openId=' + openId
        }
        window.location.href = loginUrl
      } else {
        this.notConnectedOrgName = name
        this.showNotConnectedModal = true
        this.$refs.autocomplete.clear()
      }
    },
    isUserLoggedIn () {
      let token = localStorage.getItem('token')
      if (token) {
        return true
      }
      return false
    },
    checkSSOEnabled (userObj) {
        if(userObj.ssoEnabled){
            this.showSSOModal = true
            this.ssoPath = userObj.ssoPath
            this.ssoInstitutionName = userObj.ssoInstitutionName
            this.ssoInstitutionLogo = userObj.ssoInstitutionLogo
        }
        return userObj.ssoEnabled
      },
    institutionLogin () {
      window.location.href = window.location.origin + '/sso/' + this.ssoPath

    },
    loginUser () {
      this.$v.eMail.$touch()
      this.$v.password.$touch()
      if (this.$v.eMail.$error) {
        this.eMailState = false
      }
      if (this.$v.password.$error) {
        this.passwordState = false
      }
      if (this.eMailState && this.passwordState) {
        this.showLoader = true
        this.loadUserLogin({eMail: this.eMail, password: this.password}).then(res => {
          this.showLoader = false
          let status = res.status
          if (status === 200) {
            let userObj = res.data
            if(this.checkSSOEnabled(userObj)){
                  return
              }

            if (!this.validateTnC(userObj)) {
              return this.$router.push({name: 'termsAndConditions', params: {userObj: userObj}})
            }
            return this.$router.push({name: 'dashboard'})
          } else {
            this.password = ''
            switch (status) {
              case 503:
                this.errorMessage = 'Server temporarily unavailable'
                break
              case 401:
                this.errorMessage = 'Invalid email or password'
                break
              case 400:
                this.errorMessage = 'Please enter all required fields'
                break
              default:
                this.errorMessage = 'Unexpected error code: ' + status
                break
            }
            //$('#validation-message').fadeIn('fast').delay(3000).fadeOut('slow')
          }
        })
      }
    },
    validateTnC (userObj) {
      let permission = userObj.permission
      if (!permission.institutionPermission.create && !userObj.tnCAccepted) {
        return false
      }
      return true
    },
    forgotPassword () {
      this.resetPasswordEmail = ''
      this.resetPasswordMessage = null
      this.resetPasswordEmailState = null
      this.showForgotPasswordModal = true
      this.$v.resetPasswordEmail.$touch()
    },
    resetPassword () {
      this.$v.resetPasswordEmail.$touch()
      if (this.$v.resetPasswordEmail.$error) {
        this.resetPasswordEmailState = false
      }
      if (this.resetPasswordEmailState) {
        this.loadResetPassword(this.resetPasswordEmail).then(res => {
          if (res.status === 401) {
            this.resetPasswordMessage = 'This email "' + this.resetPasswordEmail + '" does not exist.'
          } else if (res.status === 500) {
            this.resetPasswordMessage = 'Error in service call.'
          } else {
            this.resetPasswordMessage = 'Please check your registered email for password reset instructions.'
          }
        })
      }
    }
  },
  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    })
  },
  watch: {
    eMail (val) {
      if (val && !this.$v.eMail.$error) {
        this.eMailState = true
      } else {
        this.eMailState = null
      }
    },
    password (val) {
      if (val && !this.$v.password.$error) {
        this.passwordState = true
      } else {
        this.passwordState = null
      }
    },
    resetPasswordEmail (val) {
      if (val && !this.$v.resetPasswordEmail.$error) {
        this.resetPasswordEmailState = true
      } else {
        this.resetPasswordEmailState = null
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/login/components/Login.vue